export const PAGE_PATH = '/knowledge/landing/:id';
export const PAGE_PATH_DYNAMIC = (id: string) => `/knowledge/landing/${id}`;

export enum LANDING_THEME_ID {
  SELF_ESTEEM = 'self-esteem',
  DEPRESSION = 'depression',
  MENTAL_TRAUMA = 'mental-trauma',
}
